module.exports = __webpack_public_path__ + "a7360a94464713f05da30328fa3e8383.jpg";